
import {
  onMounted,
  ref,
  onUnmounted,
  defineComponent,
  reactive,
  computed,
  watch,
  toRaw,
} from 'vue';
import {
  Dropdown, Menu, Checkbox, Select,
} from 'ant-design-vue';
import { DownOutlined, SearchOutlined, } from '@ant-design/icons-vue';
import { useStore, } from 'vuex';

const { Option, } = Select;

export default defineComponent({
  components: {
    Dropdown,
    DownOutlined,
    SearchOutlined,
    // eslint-disable-next-line vue/no-unused-components
    Checkbox,
    // eslint-disable-next-line vue/no-unused-components
    Menu,
    Select,
    Option,
  },
  props: ['isAPictureSwitch',],
  emits: ['switchChange',
    'searchPoint',
    'searchChange',],
  setup (props, context) {
    const store = useStore();
    const currentMapStyle = ref<string>('light');
    // 聚合
    const clusterChecked = ref<boolean>(true);
    const clusterCheckedShow = ref<boolean>(true);
    // 风场展示
    const windChecked = ref<boolean>(false);

    // 站点展示
    const pmChecked = ref<boolean>(false);
    const pmCheckedShow = ref<boolean>(false);

    // 差值图展示
    const diffDiagramChecked = ref<boolean>(false);
    const diffDiagramCheckedShow = ref<boolean>(true);
    const switchShow = ref<boolean>(true);

    const switchRef = ref();

    // 污染源按钮高亮Tab
    const activeTab = ref<string>();

    // 后端返回的菜单权限-污染源权限
    const userGrantListApc = computed(() => store.state.userCenter.userGrantListApc);
    // 后端返回的数据权限
    const userGrantDataRights = computed(() => store.state.userCenter.userGrantDataRights);
    // 空气站图标单独配置
    const pmIconsConfig = JSON.parse(localStorage.getItem('pmIconsConfig') || '{}');

    // 图例展示
    const indexName = ref<string>('PM25');

    // 开关点击防抖定时器
    let debounceTimer: any = null;

    const menuList :any = {
      pm: [],
      source: [],
    };
    const switchsInfos = ref(menuList);

    // 搜索框值
    const searchVal = ref<string>();
    // 模糊搜索选项集合
    const searchValData = ref<any[]>([]);

    /**
     * 模糊搜索
     * @param {any} val 搜索值
     * @param {any[]} arr 搜索数据集合
     * @returns {void}
     */
    const fuzzSearch = (val: string, arr: any[]) => {
      if (!arr || !Array.isArray(arr)) {
        return [];
      }

      const result = arr.filter((item: any) => ((item.name ?? item.pointName).indexOf(val) > -1 ?
        (item.name ?? item.pointName).indexOf(val) > -1 :
        null));

      return result;
    };

    /**
     * 搜索文本框值变化时回调
     * @param {any} value 搜索结果值
     * @param {any} event 出发事件
     * @returns {void}
     */
    const searchPoint = (value: any) => {
      if (value.length) {
        context.emit('searchPoint', value);
      }
    };

    const getOpts = (allData: any, value: string) => {
      const tmpOpt: any = [];

      if (value.length) {
        Object.keys(allData).forEach((key: string) => {
          if (!allData[key].isChecked) {
            return;
          }
          let res = fuzzSearch(value, allData[key].data);

          if (res && res.length > 0) {
            res = res.map((item) => ({
              ...item,
              type: key,
            }));
          }

          tmpOpt.push(...res);
        });
      }

      searchValData.value = tmpOpt;
    };

    /**
     * 餐饮站点搜索
     * @param {any} value 输入值
     * @param {any} option 输入值
     * @returns {void}
     */
    const searchChange = (value: any, option: any) => {
      if (option) {
        searchVal.value = option.children[0].children;
        context.emit('searchChange', option);
      }
      // 搜索后置空模糊搜索集合
      searchValData.value = [];
    };

    const switchChange = (type: string) => {
      const param = {
        key: type,
        isChecked: false,
      };

      switch (type) {
      case 'cluster':
        clusterChecked.value = !clusterChecked.value;
        param.isChecked = clusterChecked.value;
        break;
      case 'pm':
        // pmChecked.value = !pmChecked.value;
        param.isChecked = pmChecked.value;
        break;
      case 'diffDiagram':
        diffDiagramChecked.value = !diffDiagramChecked.value;
        param.isChecked = diffDiagramChecked.value;
        break;
      default:
        break;
      }
      context.emit('switchChange', param);
    };

    const switchClick = (item: any, flag: boolean | string, idx?: number) => {
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
      debounceTimer = setTimeout(() => {
        // eslint-disable-next-line no-param-reassign
        item.isChecked = !item.isChecked;

        if (!flag) {
          context.emit('switchChange', item);

          return;
        }

        const itemParent = idx || idx === 0 ? switchsInfos.value.pm[idx] : {};

        let tmpData: any = [];

        tmpData = itemParent;

        if (flag) {
          // 判断选中状态
          const arr = tmpData.children?.find((cur: any) => cur.isChecked === true);

          if (arr) {
            tmpData.isChecked = true;
          } else {
            tmpData.isChecked = false;
          }
        }

        context.emit('switchChange', item);
      }, 500);
    };

    const setSwitchIsShow = (outToolsType: string, isPMParentMenu: boolean) => {
      switch (outToolsType) {
      case 'satellite':
        clusterCheckedShow.value = false;
        pmCheckedShow.value = false;
        diffDiagramCheckedShow.value = false;
        switchShow.value = false;
        break;
      case 'pm':

        /*
         * 菜单切换，如果是在站点内部菜单进行切换，switch 组件中，插值图状态不变
         * if (!isPMParentMenu) {
         *   diffDiagramChecked.value = false;
         * }
         */
        clusterCheckedShow.value = true;
        // clusterChecked.value = true;
        pmCheckedShow.value = false;
        diffDiagramCheckedShow.value = true;

        switchShow.value = true;
        break;
      case 'radar':
        // 无数据
        break;
      case 'weatherForecast':
        clusterCheckedShow.value = false;
        pmCheckedShow.value = false;
        diffDiagramCheckedShow.value = false;
        switchShow.value = false;
        break;
      case 'dust':
        clusterCheckedShow.value = false;
        pmCheckedShow.value = false;
        diffDiagramCheckedShow.value = false;
        switchShow.value = false;
        break;
      default:
        break;
      }
    };

    // 图例切换
    const setLegend = (type: string) => {
      indexName.value = type;
    };

    const cleanDatas = () => {
      clusterCheckedShow.value = true;
      pmCheckedShow.value = false;
      diffDiagramCheckedShow.value = true;
      switchShow.value = true;
    };
    const resetSwicthControl = () => {
      diffDiagramChecked.value = false;
    };

    const changeTab = (activeId: string) => {
      activeTab.value = activeId;
    };

    // 设置权限菜单
    const resetRight = (curMenu: any[]) => {
      if (!curMenu || !curMenu.length) {
        switchsInfos.value.pm = [];

        return;
      }

      // 默认选择
      const defaultChecks = props.isAPictureSwitch ? ['country',
        'province',
        'city',
        'micro',] : ['country',];

      const microPM: any = {
        label: '微站',
        key: 'mircoPM',
        keyTypes: ['micro', 'moveTrack',],
        isChecked: props.isAPictureSwitch,
        children: [],
      };

      let pmTmp: any[] = [];
      let temp: any = [];

      curMenu.forEach((item: any) => {
        const { key, } = item;

        if (!key) return;
        temp = item;

        if (defaultChecks.includes(key)) {
          temp.isChecked = true;
        } else {
          temp.isChecked = false;
        }

        if (props.isAPictureSwitch && microPM.keyTypes.includes(key)) {
          microPM.children.push(temp);

          return;
        }
        pmTmp.push(temp);
      });
      if (props.isAPictureSwitch) {
        pmTmp.push(microPM);
      }
      if (!props.isAPictureSwitch) {
        pmTmp = pmTmp.filter((ele:any) => ele.id !== '400305');
      }

      switchsInfos.value.pm = pmTmp;
    };

    // 根据用户数据设置空气站点图标
    const resetPmIcons = (pmMenu: any) => {
      if (!pmMenu) return;
      pmMenu.forEach((item: any) => {
        const { children, key, } = item;

        if (pmIconsConfig[key]) {
          // eslint-disable-next-line no-param-reassign
          item.icons = pmIconsConfig[key].icon;

          return;
        }

        if (children && children.length) {
          resetPmIcons(children);
        }
      });
    };

    const resetSource = (rights:any[]) => {
      if (!rights || !rights.length) {
        switchsInfos.value.source = [];

        return;
      }
      const temp: any = [];

      rights.forEach((item: any) => {
        // temp = item;
        const { buttonChildren, } = item;

        if (buttonChildren && buttonChildren.length) {
          buttonChildren.forEach((i: any) => {
            // eslint-disable-next-line no-param-reassign
            i.isChecked = false;
          });
          temp.push(toRaw(item));
          // switchsInfos.value.source.push(toRaw(temp));
        }
      });
      switchsInfos.value.source = temp;
      activeTab.value = switchsInfos.value.source[0]?.id;
    };

    // 数据权限-赋给switchsInfos.value.source
    watch(userGrantDataRights,(value) => {
      if (!value || !value.length) {
        switchsInfos.value = menuList;

        return;
      }
      const pollutionIds = props.isAPictureSwitch ? ['4001',
        '4002',
        '4007',] : ['4001', '4002',];
      const pollutionRights = value.filter((item:any) => pollutionIds.includes(item.id));
      const pmRights = value.filter((item:any) => item.id === '4003');

      resetSwicthControl();
      resetRight(pmRights?.[0]?.buttonChildren);
      resetSource(pollutionRights);
      resetPmIcons(switchsInfos.value.pm);
    }, { immediate: true, });

    onMounted(() => {
      cleanDatas();
      //  resetSwicthControl();
    });
    onUnmounted(() => {
      cleanDatas();
      clearTimeout(debounceTimer);
    });

    return {
      switchShow,
      currentMapStyle,
      switchsInfos,
      clusterChecked,
      windChecked,
      pmChecked,
      pmCheckedShow,
      clusterCheckedShow,
      diffDiagramChecked,
      diffDiagramCheckedShow,
      indexName,
      switchRef,
      searchVal,
      searchValData,
      switchChange,
      switchClick,
      cleanDatas,
      setSwitchIsShow,
      setLegend,
      resetSwicthControl,
      changeTab,
      activeTab,
      searchPoint,
      searchChange,
      getOpts,
    };
  },
});
